import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-customer-inactivity-modal',
    templateUrl: './customer-inactivity-modal.component.html',
    styleUrls: ['./customer-inactivity-modal.component.scss'],
    standalone: false
})
export class CustomerInactivityModalComponent extends CfetBaseComponent {

  @Input() openModal: string;
  @Output() closeInactivityModal = new EventEmitter<any>();

  constructor() { super(); }


  closePopup (event: any, modalAction: string) {
    if (event.type === 'click' || event.key === 'Enter' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeInactivityModal.emit('modalClose');
    }
  }

  continueWorking (event, modalAction: string) {
    if (event.type === 'click' || event.key === 'Enter' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeInactivityModal.emit('modalClose');
    }
  }

}
